// The selected interface language owns notice language, not the current route.
// Importing this module does not start session discovery or notice requests.
export function desktopPrivacyLocale() {
  return window.__fishystuffLanguage.current().locale === "de-DE" ? "de-DE" : "en-US";
}

export function desktopPrivacyPagePath() {
  return desktopPrivacyLocale() === "de-DE" ? "/de-DE/desktop/privacy/" : "/desktop/privacy/";
}

export function desktopPrivacyApiUrl(format = "html", version = null) {
  if (!["html", "rss", "text", "history"].includes(format)) {
    throw new TypeError("Unsupported Desktop privacy notice format.");
  }
  const url = new URL(window.__fishystuffResolveApiUrl("/api/v1/account/desktop-privacy"));
  url.searchParams.set("locale", desktopPrivacyLocale());
  url.searchParams.set("format", format);
  if (version !== null) {
    if (!/^sha256-[A-Za-z0-9_-]{43}$/u.test(version)) throw new TypeError("Invalid Desktop notice version.");
    url.searchParams.set("version", version);
  }
  return url.href;
}
